import {
  ADD_CONTACTS,
  ADD_CONTACTS_FAILURE,
  ADD_CONTACTS_SUCCESS,
  //
  DELETE_CONTACTS,
  DELETE_CONTACTS_FAILURE,
  DELETE_CONTACTS_SUCCESS,
  //
  EDIT_CONTACTS,
  EDIT_CONTACTS_FAILURE,
  EDIT_CONTACTS_SUCCESS,
  //
  FETCH_CONTACTS,
  FETCH_CONTACTS_FAILURE,
  FETCH_CONTACTS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchContact = (payload) => ({
  type: FETCH_CONTACTS,
  payload,
});
export const fetchContactSuccess = (payload) => ({
  type: FETCH_CONTACTS_SUCCESS,
  payload,
});
export const fetchContactFailure = (payload) => ({
  type: FETCH_CONTACTS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addContact = (payload) => ({
  type: ADD_CONTACTS,
  payload,
});
export const addContactSuccess = (payload) => ({
  type: ADD_CONTACTS_SUCCESS,
  payload,
});
export const addContactFailure = (payload) => ({
  type: ADD_CONTACTS_FAILURE,
  payload,
});
// EDIT
export const editContact = (payload) => ({
  type: EDIT_CONTACTS,
  payload,
});
export const editContactSuccess = (payload) => ({
  type: EDIT_CONTACTS_SUCCESS,
  payload,
});
export const editContactFailure = (payload) => ({
  type: EDIT_CONTACTS_FAILURE,
  payload,
});
// DELETE
export const deleteContact = (payload) => ({
  type: DELETE_CONTACTS,
  payload,
});
export const deleteContactSuccess = (payload) => ({
  type: DELETE_CONTACTS_SUCCESS,
  payload,
});
export const deleteContactFailure = (payload) => ({
  type: DELETE_CONTACTS_FAILURE,
  payload,
});
